import {none, Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import {store} from "../../navigation/ReduxProvider";
import Account from "../../model/account/Account";

/**
 * Gets account.
 * @param partnerBrandId partner brand id of account.
 * @param {string} accountCode account code to get.
 * @param {RootState} state State of the redux.
 * @returns {Option<Account>} account.
 */
export function getAccount(partnerBrandId: string, accountCode: string, state: RootState = store.getState()): Option<Account> {
	const accounts = state.partnerBrand.accounts[partnerBrandId];
	return accounts ? option(accounts.filter(a => a.code === accountCode)[0]) : none;
}
